import { useQueryClient } from "@tanstack/react-query";
import { useDataProvider, useTranslate } from "ra-core";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { IS_DEMO } from "../env";

/**
 * FakeRest demo only (renders nothing elsewhere): loads the rep-stats sample data (repStatsDemoSeed.ts) so the
 * Classement, the rep page and Coûts & CAC have something to show. `enabled` forces it on in component tests.
 */
export const DemoSampleDataButton = ({
  enabled = IS_DEMO,
}: {
  enabled?: boolean;
}) => {
  const t = useTranslate();
  const dp = useDataProvider();
  const queryClient = useQueryClient();
  const [busy, setBusy] = useState(false);
  if (!enabled) return null;
  return (
    <div className="mt-3 flex flex-col items-start gap-1 rounded-lg border border-dashed p-3">
      <p className="text-xs text-muted-foreground">
        {t("gavion.rep_stats.demo_seed.hint")}
      </p>
      <Button
        type="button"
        size="sm"
        variant="outline"
        disabled={busy}
        className="min-h-11 md:min-h-8"
        onClick={async () => {
          setBusy(true);
          try {
            const { seedRepStatsDemo } = await import("./repStatsDemoSeed");
            await seedRepStatsDemo(dp);
            await queryClient.invalidateQueries();
          } finally {
            setBusy(false);
          }
        }}
      >
        {t(
          busy
            ? "gavion.rep_stats.demo_seed.loading"
            : "gavion.rep_stats.demo_seed.button",
        )}
      </Button>
    </div>
  );
};
